import type { CSSProperties, PointerEvent } from "react";
import { RESIZE_HANDLES } from "./layout-canvas-constants";
import type { ResizeHandle } from "./layout-canvas-utils";

const HANDLE_SIZE = 8;
const HANDLE_OFFSET = -(HANDLE_SIZE / 2);

const CURSOR_BY_HANDLE: { [key in ResizeHandle]: CSSProperties["cursor"] } = {
  n: "ns-resize",
  s: "ns-resize",
  e: "ew-resize",
  w: "ew-resize",
  ne: "nesw-resize",
  sw: "nesw-resize",
  nw: "nwse-resize",
  se: "nwse-resize",
};

const POSITION_BY_HANDLE: { [key in ResizeHandle]: CSSProperties } = {
  nw: { top: HANDLE_OFFSET, left: HANDLE_OFFSET },
  n: { top: HANDLE_OFFSET, left: "50%", marginLeft: HANDLE_OFFSET },
  ne: { top: HANDLE_OFFSET, right: HANDLE_OFFSET },
  w: { top: "50%", left: HANDLE_OFFSET, marginTop: HANDLE_OFFSET },
  e: { top: "50%", right: HANDLE_OFFSET, marginTop: HANDLE_OFFSET },
  sw: { bottom: HANDLE_OFFSET, left: HANDLE_OFFSET },
  s: { bottom: HANDLE_OFFSET, left: "50%", marginLeft: HANDLE_OFFSET },
  se: { bottom: HANDLE_OFFSET, right: HANDLE_OFFSET },
};

export type LayoutCanvasHandlesProps = {
  disabled?: boolean;
  onPointerDownHandle: (
    handle: ResizeHandle,
    event: PointerEvent<HTMLDivElement>,
  ) => void;
};

export function LayoutCanvasHandles({
  disabled,
  onPointerDownHandle,
}: LayoutCanvasHandlesProps) {
  if (disabled) {
    return null;
  }

  return (
    <>
      {RESIZE_HANDLES.map((handle) => (
        <div
          key={handle}
          className="absolute bg-white border border-blue-500 rounded-sm"
          style={{
            width: HANDLE_SIZE,
            height: HANDLE_SIZE,
            cursor: CURSOR_BY_HANDLE[handle],
            ...POSITION_BY_HANDLE[handle],
          }}
          onPointerDown={(event) => onPointerDownHandle(handle, event)}
        />
      ))}
    </>
  );
}
